export const CAPITAL_PROTECTION = [
  {
    key: 'protectionType',
    displayValue: 'Protection Type',
  },
  {
    key: 'description',
    displayValue: 'Description',
  },
];
